import React from 'react';

const points = { fata: [150, 42], spate: [150, 310], capota: [150, 93], plafon: [150, 176],
  portbagaj: [150, 262], stanga_fata: [93, 130], stanga_spate: [93, 230],
  dreapta_fata: [207, 130], dreapta_spate: [207, 230], parbriz: [150, 132] };

export default function VehicleDamageDiagram({ marks = [] }) {
  return <svg viewBox="0 0 300 350" role="img" aria-label="Schiță vehicul văzut de sus, fața în partea de sus" style={{ width: '100%', maxWidth: 240, maxHeight: 260 }}>
    <text x="150" y="18" textAnchor="middle" fontSize="12">FAȚĂ</text>
    <text x="25" y="180" textAnchor="middle" fontSize="10" transform="rotate(-90 25 180)">STÂNGA</text>
    <text x="275" y="180" textAnchor="middle" fontSize="10" transform="rotate(90 275 180)">DREAPTA</text>
    <g fill="#f5f7fa" stroke="#334155" strokeWidth="2">
      <rect x="84" y="32" width="132" height="290" rx="40" />
      <path d="M102 67 Q150 51 198 67 L193 117 L107 117 Z" />
      <path d="M107 120 L193 120 L185 145 L115 145 Z" />
      <rect x="113" y="149" width="74" height="70" rx="8" />
      <path d="M115 224 L185 224 L195 246 L105 246 Z" />
      <path d="M105 251 L195 251 L198 287 Q150 306 102 287 Z" />
      <path d="M93 100 L93 245 M207 100 L207 245" />
      <rect x="75" y="92" width="8" height="40" rx="2" fill="#334155" />
      <rect x="217" y="92" width="8" height="40" rx="2" fill="#334155" />
      <rect x="75" y="240" width="8" height="40" rx="2" fill="#334155" />
      <rect x="217" y="240" width="8" height="40" rx="2" fill="#334155" />
    </g>
    {Object.entries(points).map(([zone, [x, y]]) => {
      const indices = marks.map((mark, index) => mark.zona === zone ? index + 1 : null).filter(Boolean);
      return indices.length ? <g key={zone}><circle cx={x} cy={y} r="13" fill="white" stroke="#991b1b" strokeWidth="2" />
        <text x={x} y={y + 4} textAnchor="middle" fontSize="10" fill="#991b1b" fontWeight="bold">{indices.join(',')}</text></g> : null;
    })}
    <text x="150" y="343" textAnchor="middle" fontSize="12">SPATE</text>
  </svg>;
}
